




































import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import { NavigationGuard, Route } from 'vue-router';
import { isEqual } from 'lodash';
import ResourcesIndexPage from '../ResourcesIndexPage.vue';
import RightSidebar from '@/components/resources/orders/RightSidebar.vue';
import OrdersDatatable from '@/resources/sales/orders/OrdersDatatable';
import Datatable from '@/components/datatables/Datatable.vue';
import TimeFilter from '@/components/forms/fields/orders/TimeFilter.vue';
import CreateEditOrderPage from '@/pages/resources/special/CreateEditOrderPage.vue';

const ordersDatatable = new OrdersDatatable();

@Component({
  components: { ResourcesIndexPage, RightSidebar, CreateEditOrderPage },
  inheritAttrs: false,
})
export default class OrdersIndexPage extends Vue {
  @Prop({ required: true, type: String }) mode!: 'index' | 'edit' | 'create';
  @Prop({ required: false, type: String }) orderId?: string; // `undefined` when `mode` is `'index'` or `'create'`.
  @Prop({ type: Object, required: true }) filterQuery!: Route['query'] & Datatable['query'];
  @Prop({ required: true, type: Vue }) filtersEventBus!: Vue;

  created() {
    this.filtersEventBus.$on('time-filter-change', this.onTimeFilterChange);
  }
  beforeDestroy() {
    this.filtersEventBus.$off('time-filter-change', this.onTimeFilterChange);
  }

  onTimeFilterChange(newVal: TimeFilter['value']) {
    const newQuery = {
      ...this.filterQuery,
      created_from: newVal.from,
      created_till: newVal.till,
    };
    delete newQuery.page;
    this.$emit('update:query', newQuery);
  }

  onDatatableFilterUpdate(e: Datatable['query']) {
    this.$emit('update:query', {
      // Keep in mind that props can go missing (e.g. `search` and `count`).
      created_from: this.filterQuery.created_from,
      created_till: this.filterQuery.created_till,
      ...e,
    });
  }

  get isEditOrCreateRoute(): boolean {
    return this.$route.name !== 'orders.index';
  }
  closeSidebar() {
    this.$router.push({ name: 'orders.index' });
  }
  get datatable() {
    return ordersDatatable;
  }
  beforeRouteEnter(...[to, from, next]: Parameters<NavigationGuard<this>>) {
    // Preserve datatable filtering query so it doesn't reset if we open/close the sidebar.
    if (
      (['orders.index', 'orders.create', 'orders.edit'] as any[]).includes(from.name)
      && to.name !== from.name
      && !isEqual(to.query, from.query)
    ) {
      next({ ...to, query: from.query });
      return;
    }
    next();
  }
}
